// src/hooks/useDateTimeFilter.js
import { useState } from 'react';

/**
 * Конвертация: "01-04-2025 14:30:00" → "2025-04-01T14:30:00" (для input)
 */
export const toInputFormat = (datetimeStr) => {
  if (!datetimeStr) return '';
  try {
    const [d, m, y, h, i, s] = datetimeStr.split(/[-\s:]/);
    return `${y}-${m}-${d}T${h}:${i}:${s}`;
  } catch (error) {
    console.error('Error in toInputFormat:', error, 'Input:', datetimeStr);
    return '';
  }
};

/**
 * Конвертация: "2025-04-01T14:30:00" → "01-04-2025 14:30:00" (для бэкенда)
 */
export const toBackendFormat = (datetimeLocalStr) => {
  if (!datetimeLocalStr) return '';
  const [datePart, timePart] = datetimeLocalStr.split('T');
  const [y, m, d] = datePart.split('-');
  const [h, i, s] = timePart.split(':');
  return `${d}-${m}-${y} ${h}:${i}:${s}`;
};

/**
 * Дефолтные даты
 */
export const getDefaultDateFrom = () => {
  const date = new Date();
  date.setDate(date.getDate() - 7);
  date.setHours(0, 0, 0, 0);
  return toBackendFormat(date.toISOString().slice(0, 19).replace('T', ' '));
};

export const getDefaultDateTo = () => {
  const date = new Date();
  date.setHours(23, 59, 59, 0);
  return toBackendFormat(date.toISOString().slice(0, 19).replace('T', ' '));
};

/**
 * Проверка валидности datetime-local
 */
const isValidDateTime = (value) => {
  if (!value) return true;
  const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  const regex2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
  if (!regex.test(value) && !regex2.test(value)) return false;
  const date = new Date(value);
  return !isNaN(date.getTime()) && date.getFullYear() === parseInt(value.slice(0, 4));
};

/**
 * Универсальный хук для фильтрации по дате и времени
 */
export const useDateTimeFilter = (initialFrom = '', initialTo = '') => {
  const [filters, setFilters] = useState({
    date_filter_from: initialFrom,
    date_filter_to: initialTo,
  });
  const [tempValues, setTempValues] = useState({
    date_filter_from: '',
    date_filter_to: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTempValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Пустое значение
    if (!value) {
      if (filters[name] !== '') {
        setFilters((prev) => ({ ...prev, [name]: '' }));
      }
      setTempValues((prev) => ({ ...prev, [name]: '' }));
      return;
    }

    // Проверка формата
    if (!isValidDateTime(value)) {
      setTempValues((prev) => ({ ...prev, [name]: filters[name] }));
      return;
    }

    // Дополняем секунды
    const newValue = value.length === 16 ? value + ':00' : value;

    if (filters[name] !== newValue) {
      setFilters((prev) => ({ ...prev, [name]: newValue }));
    }

    setTempValues((prev) => ({ ...prev, [name]: '' }));
  };

  const reset = () => {
    setFilters({ date_filter_from: '', date_filter_to: '' });
    setTempValues({ date_filter_from: '', date_filter_to: '' });
  };

  return {
    filters,
    tempValues,
    handleChange,
    handleBlur,
    reset,
  };
};

export default useDateTimeFilter;

